module.exports = __webpack_public_path__ + "static/media/photo172.9f82dfd2.jpg";